export default __webpack_public_path__ + "static/language-ant-c9fbdb4d8430761988db14f89d5f9b66.png";